import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { UncancelActionContext } from "./UncancelActionContext";
import store from "@beeldit/core/services/store";

function useCancel(modelConfig: any) {
  const { elementId, setShowModal } = useContext(UncancelActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("bookings/uncancel", { id: elementId })
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useCancel;
